import { NavLink } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import { useT } from '../../i18n';
import { navFor } from '../../config/navigation';
import { PoweredBy } from '../common/Brand';

export function Sidebar() {
  const { role } = useApp();
  const t = useT();
  return (
    <aside className="print:hidden sticky top-0 hidden h-screen w-64 shrink-0 flex-col bg-sc-deep text-white lg:flex" data-testid="sidebar">
      <p className="px-6 pb-3 pt-7 text-[11px] font-bold uppercase tracking-[0.18em] text-teal-200/60">{t('nav.menu')}</p>
      <nav className="flex-1 space-y-1 overflow-y-auto px-3">
        {navFor(role).map((item) => (
          <NavLink
            key={item.key}
            to={item.path}
            end
            data-testid={`sidebar-link-${item.key}`}
            className={({ isActive }) =>
              `group relative flex h-12 items-center gap-3 rounded-xl px-3 text-[15px] font-medium transition-colors duration-200 ${
                isActive ? 'bg-white/10 text-white' : 'text-teal-50/80 hover:bg-white/5 hover:text-white'
              }`
            }
          >
            {({ isActive }) => (
              <>
                {isActive && <span className="absolute left-0 top-2 h-8 w-1 rounded-r-full bg-brand" />}
                <item.icon className="h-5 w-5 shrink-0" />
                <span className="flex-1 truncate">{t(`nav.${item.key}`)}</span>
                {item.soon && (
                  <span className="rounded-md bg-white/10 px-1.5 py-0.5 text-[10px] font-semibold uppercase text-teal-100/70">{t('nav.soon')}</span>
                )}
              </>
            )}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-white/10 px-6 py-5">
        <PoweredBy light />
      </div>
    </aside>
  );
}
